import React, { useEffect, useRef, useState } from "react";
import CardAutomate from "./Components/CardAutomate/CardAutomate";
import { AutomateDataComponent } from "./utils/automatesJson";
import styles from "./automate.module.css";
import { useDispatch, useSelector } from "react-redux";
import k from "../../assets/k.svg";
import { ReactComponent as IconLock } from "./panelAutomate/assets/icon_lock.svg";
import { ReactComponent as Automation } from "../../assets/automation.svg";
import { ReactComponent as AutomationBlack } from "../../assets/automateBlack.svg";
import { ReactComponent as EmptyAutomate } from "../../assets/emptyAutomate.svg";
import { ReactComponent as AutomateEmpty } from "../../assets/automateEmpty.svg";
import { ReactComponent as AutomateWhiteGrey } from "../../assets/automateWhiteGrey.svg";
import { IoShareSocialSharp } from "react-icons/io5";
import searchMagnify from "../../assets/searchMagnify.svg";
import { ReactComponent as FilterIcon1InExplore }  from "../../assets/filterIcon1InExplore.svg"

import automation from "../../assets/automation.svg";

import { ReactComponent as AutomationIconGrey } from "../../assets/automationIconGrey.svg";
import IniAutomate from "./panelAutomate/IniAutomate";
import HeaderCard from "../HeaderCard/HeaderCard";
import Button from "../Button/Button";
import useFocusShortcut from "../../../../utils/useFocusShortcut";
import {
  driveIsAuthenticated,
  getAuth,
  getUserAutomatiosByInputSearch,
  getUserDevices,
  oneDriveIsAuthenticated,
  outlookIsAuthenticated,
  telematelIsAuthenticated,
} from "../../../../actions/automate";
import { useTranslation } from "react-i18next";
import PaginationTables from "../PaginationTables/PaginationTables";
import FiltersDropdownContainer from "../FiltersDropdownContainer/FiltersDropdownContainer";
import { setAutomateSelected } from "../../../../slices/automateSlices";
import { setRoleAutomateSlice, setSelectedAutomationDataSlice, setTypeContentAutomateSlice } from "../../../../slices/userSlices";

const Automate = ({
  close,
  newData,
  typeContent,
  isModalAutomate,
  setIsModalAutomate,
  isAnimating,
  setIsAnimating,
  type,
  showDeletePopup,
  setShowDeletePopup,
  setSelectedAutomateToDelete,
  search,
  setHideAutomate,
  hideAutomate,
  setRoleAutomate,
}) => {
  const data = AutomateDataComponent();
  const [t] = useTranslation("Automate");
  const { showModal } = useSelector((state) => state.user);
  const { userAutomations } = useSelector((state) => state.automate);
  const { user } = useSelector((state) => state.user);
  const [selectedType, setSelectedType] = useState(t("all"));
  const [dataFilter, setDataFilter] = useState(data || newData);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [showIniAutomate, setShowIniAutomate] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [animationDirection, setAnimationDirection] = useState("in");
  const [visible, setVisible] = useState(true);
  const [animate, setAnimate] = useState(false);
  const [animateState, setAnimateState] = useState(null);
  const [filterCategory, setfilterCategory] = useState(null);
  const [filteredDate, setFilteredDate] = useState(null);
  const [selected, setSelected] = useState(1)
  const [selected2, setSelected2] = useState(1)

  // useEffect(() => {
  //   console.log('showModal', showModal)
  //   if (showModal == 'automate') {
  //     setShowIniAutomate(true)
  //   }
  // }, [showModal]);

  // const triggerAnimation = () => {
  //   setAnimate(false);
  //   setTimeout(() => setAnimate(true), 300);
  // };

  const handleShowContentAutomate = (
    type,
    automationData,
    fromSelectedAutomation
  ) => {
    if (fromSelectedAutomation) {
      dispatch(setTypeContentAutomateSlice(""))
      setTimeout(() => {
        dispatch(setTypeContentAutomateSlice(type))
      dispatch(setSelectedAutomationDataSlice(automationData))
      }, 300);
    } else {
      dispatch(setTypeContentAutomateSlice(type))
      dispatch(setSelectedAutomationDataSlice(automationData))
    }
  };

  useEffect(() => {
    if (search) {
      if (userAutomations.length > 0) {
        let automationData = userAutomations.find(
          (automation) => automation._id == search
        );
        dispatch(setAutomateSelected(automationData));
        typeContent ? typeContent(automationData?.type, automationData):
        handleShowContentAutomate(automationData?.type, automationData)
      }
    }
  }, [userAutomations]);

  const handleDataFilter = (searchTerm) => {
    const filteredData = data.filter((card) =>
      card.automateName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setDataFilter(filteredData);
  };

  const userId = useSelector((state) => state?.user?.user?.id);
  useEffect(() => {
    dispatch(getAuth("Gmail"));
    dispatch(getUserDevices(userId));
    dispatch(outlookIsAuthenticated());
    dispatch(driveIsAuthenticated());
    dispatch(oneDriveIsAuthenticated());
    dispatch(telematelIsAuthenticated());
  }, []);

  useEffect(() => {
    if (searchTerm === "") {
      setDataFilter(data || newData);
    } else {
      handleDataFilter(searchTerm);
    }
  }, [searchTerm]);

  const handleCloseNewClient = () => {
    setIsAnimating(true);
    setAnimationDirection("out");
    setAnimateState("out");
    window.history.pushState({}, "", `${window.location.pathname}`);
    setTimeout(() => {
      setIsModalAutomate(false);
      setIsAnimating(false);
      close();
    }, 300);
  };

  useEffect(() => {
    if (hideAutomate) {
      setVisible(false);
      setAnimateState("out");
      setTimeout(() => {
        setAnimateState(null);
      }, 300);
    } else {
      setVisible(true);
      setAnimateState("init");
      setTimeout(() => setAnimateState("in"), 10);
    }
  }, [hideAutomate]);

  const searchInputRef = useRef(null);

  useFocusShortcut(searchInputRef, "k");

  let filteredData = userAutomations?.filter((item) => {
    if (selectedType == t("all")) return true;
    if (selectedType == t(`${item.role}`)) return true;
    // if (selectedType == t("output")) return item.role;
    // return true;
  });

  const now = new Date();
  let limitDate = new Date();
  switch (filteredDate) {
    case "1month":
      limitDate.setMonth(now.getMonth() - 1);
      break;
    case "3month":
      limitDate.setMonth(now.getMonth() - 3);
      break;
    case "6month":
      limitDate.setMonth(now.getMonth() - 6);
      break;
    case "1year":
      limitDate.setFullYear(now.getFullYear() - 1);
      break;
    default:
      limitDate = null;
  }

  if (filterCategory)
    filteredData = filteredData?.filter(
      (item) => item.category == filterCategory
    );
  if (filteredDate) {
    filteredData = filteredData?.filter(
      (item) => item.createdAt && new Date(item.createdAt) >= limitDate
    );
  }

  const inputFilterAutomate = (e) => {
    const inputSearchTerm = e.target.value;
    setSearchTerm(inputSearchTerm);
    dispatch(
      getUserAutomatiosByInputSearch({
        userId: user.id,
        inputValue: inputSearchTerm,
      })
    );
  };

  const [limit, setLimit] = useState(20);
  const [page, setPage] = useState(0);

  const [selectedOption, setSelectedOption] = useState({
    [t("alphabeticOrder")]: "A-Z",
    [t("orderByType")]: t("all"),
  });
  const options = [
    {
      name: "Orden Alfabético",
      label: t("alphabeticOrder"),
      subOptions: [
        { display: "A-Z", value: "A-Z" },
        { display: "Z-A", value: "Z-A" },
      ],
    },
    {
      name: t("orderByType"),
      label: t("orderByType"),
      subOptions: [
        { display: t("all"), value: t("all") },
        { display: t("input"), value: t("input") },
        { display: t("output"), value: t("output") },
      ],
    },
    {
      name: t("orderByCategory"),
      label: t("orderByCategory"),
      subOptions: [
        { display: t("Import"), value: t("Import") },
        { display: t("ERP"), value: t("ERP") },
        { display: t("CRM"), value: t("CRM") },
        {
          display: t("PublicAdministration"),
          value: t("PublicAdministration"),
        },
        { display: t("Files"), value: t("Files") },
        { display: t("Communications"), value: t("Communications") },
        { display: t("Meetings"), value: t("Meetings") },
        { display: t("AI"), value: t("AI") },
        { display: t("HR"), value: t("HR") },
        { display: t("Logistics"), value: t("Logistics") },
        { display: t("Fintech"), value: t("Fintech") },
        { display: t("Ecommerce"), value: t("Ecommerce") },
      ],
    },
    {
      name: "date",
      label: t("date"),
      subOptions: [
        { display: t("1month"), value: "1month" },
        { display: t("3month"), value: "3month" },
        { display: t("6month"), value: "6month" },
        { display: t("1year"), value: "1year" },
      ],
    },
  ];
  useEffect(() => {
    setSelectedType(selectedOption[t("orderByType")]);
  }, [selectedOption[t("orderByType")]]);

  useEffect(() => {
    setfilterCategory(selectedOption[t("orderByCategory")]);
  }, [selectedOption[t("orderByCategory")]]);

  useEffect(() => {
    setFilteredDate(selectedOption[t("date")]);
  }, [selectedOption[t("date")]]);

  const handleIniAutomate = () => {
    setShowIniAutomate(false);
  };

 console.log('esto es filteredData',filteredData)

  return (
    <>
      {/* <div className={styles.container} onClick={handleCloseNewClient}></div> */}
      <div
        style={{ opacity: visible ? 1 : 0 }}
        // ${animateState === "init" ? styles.scaleInitial : ""}
        // ${animateState === "in" ? styles.scaleIn : ""}
        // ${animateState === "out" ? styles.scaleOut : ""}
        className={`
          ${styles.content}
          ${styles.expand}
          ${
            userAutomations?.length <= 0 && searchTerm.length === 0
              ? styles.iniAutomateContainer
              : showIniAutomate
                ? styles.iniAutomateContainer
                : styles.automateContainer
          }
        `}
      >
        <div className={styles.searchContainer}>
              <div className={styles.searchInputWrapper}>
                <div className={styles.searchIcon}>
                  <img src={searchMagnify} alt="searchMagnify" />
                </div>
                <input
                  ref={searchInputRef}
                  type="text"
                  placeholder={t("searchYourAutomates")}
                  className={styles.searchInput}
                  value={searchTerm}
                  onChange={(e) => inputFilterAutomate(e)}
                />
                <FiltersDropdownContainer
                  setSelectedFilters={setSelectedOption}
                  selectedFilters={selectedOption}
                  options={options}
                />
                <FilterIcon1InExplore />
                <div
                  style={{ marginLeft: "7px" }}
                  className={styles.searchIconsWrappers}
                >
                  <img src={k} alt="kIcon" />
                </div>
              </div>
            </div>

            <div id="typeContact" className={`${styles.typeContact}`}>

<React.Fragment >
  <button
    className={`${styles.categoryButton} ${styles.selected}`}
    onClick={() => setSelected(1)}
    type="button"
  >
    {t('completedSuccessfully')}
    <span>0</span>
  </button>
</React.Fragment>
<React.Fragment >
  <button
    className={`${styles.categoryButton} ${styles.selected}`}
    onClick={() => setSelected(2)}
    type="button"
  >
    {t('failedByError')}
    <span>0</span>
  </button>
</React.Fragment>
<React.Fragment >
  <button
    className={`${styles.categoryButton} ${styles.selected}`}
    onClick={() => setSelected(3)}
    type="button"
  >
    {t('pendingGluing')}
    <span>0</span>
  </button>
</React.Fragment>
<React.Fragment >
  <button
    className={`${styles.categoryButton} ${styles.selected}`}
    onClick={() => setSelected(4)}
    type="button"
  >
    {t('tokenConsumption')}
    <span>0</span>
  </button>
</React.Fragment>
<React.Fragment >
  <button
    className={`${styles.categoryButton} ${styles.selected}`}
    onClick={() => setSelected(5)}
    type="button"
  >
    {t('cost')}
    <span>0</span>
  </button>
</React.Fragment>

</div>

   

            <div className={styles.buttonsContainer} style={{width:"auto"}}>
            <div id="typeContact" className={`${styles.typeContact}`} 
            style={{padding: 0,
              width: 'auto'}}>

<React.Fragment >
  <button
    className={`${styles.categoryButton} ${selected2 == 1 && styles.selected}`}
    onClick={() => {setSelected2(1)
      setSelectedType(t('all'))
    }}
    type="button"
  >
    {t('allSingular')}
    {selected2 == 1 && <span>0</span>}
  </button>
</React.Fragment>
<React.Fragment >
  <button
    className={`${styles.categoryButton} ${selected2 == 2 && styles.selected}`}
    onClick={() => {setSelected2(2)
      setSelectedType(t('ERP'))
    }}
    type="button"
  >
    {t('ERP')}
    {selected2 == 2 && <span>0</span>}
  </button>
</React.Fragment>
<React.Fragment >
  <button
    className={`${styles.categoryButton} ${selected2 == 3 && styles.selected}`}
    onClick={() => {setSelected2(3)
      setSelectedType(t('CMR'))
    }}
    type="button"
  >
    {t('CMR')}
    {selected2 == 3 && <span>0</span>}
  </button>
</React.Fragment>
</div>
<div className={styles.rightButtonsContainer} >
              <Button
                headerStyle={{ all: "unset" }}
                action={() => setShowIniAutomate((prev) => !prev)}
              >
                <div className={styles.automationIconContainer}>
                  <AutomateWhiteGrey fill="#fff" />
                </div>
              </Button>
              <Button
                action={() => {
                  typeContent ?(
                  typeContent("Gmail", {
                    labels: [
                      {
                        name: "",
                        conditions: [
                          {
                            title: "",
                            description: "",
                          },
                        ],
                        newCondition: {
                          title: "",
                          description: "",
                        },
                        filters: [
                          {
                            id: Date.now(),
                            conditionCurrency: {
                              title: "",
                              description: "",
                            },
                            conditionOperator: "CONTAINS",
                            conditionValue: "",
                            type: "Condition",
                          },
                        ],
                      },
                    ],
                    // showContentSelectInfoToProcess:{
                    //   info9:true
                    // }
                  })): handleShowContentAutomate("Gmail", {
                    labels: [
                      {
                        name: "",
                        conditions: [
                          {
                            title: "",
                            description: "",
                          },
                        ],
                        newCondition: {
                          title: "",
                          description: "",
                        },
                        filters: [
                          {
                            id: Date.now(),
                            conditionCurrency: {
                              title: "",
                              description: "",
                            },
                            conditionOperator: "CONTAINS",
                            conditionValue: "",
                            type: "Condition",
                          },
                        ],
                      },
                    ],
                    // showContentSelectInfoToProcess:{
                    //   info9:true
                    // }
                  })
                  setRoleAutomate ? setRoleAutomate("input"):
                  dispatch(setRoleAutomateSlice("input"))
                }}
              >
                {" "}
                {t("newAutomate")}
              </Button>
            </div>
            </div>

        {showIniAutomate ||
        (userAutomations?.length <= 0 && searchTerm.length) === 0 ? (
          <div className={styles.iniContainer}>
            <IniAutomate setShowIniAutomate={setShowIniAutomate} typeContent={typeContent} handleShowContentAutomate={handleShowContentAutomate}  type={type} />
          </div>
        ) : (
          <div className={styles.automate_content}>
            

            <div className={styles.contentContainerScroll}>
              <div className={styles.contentContainer}>
                {!filteredData?.length && (
                  <div className={styles.noAutomations}>
                    <AutomateEmpty
                      width={180}
                      height={180}
                      style={{ padding: "40px" }}
                    />

                    <span style={{ fontWeight: "bold" }}>
                      {t("noAutomationsAvailable")}
                    </span>
                    <div className={styles.noAutomationsTextWrapper}>
                      <span style={{ color: "var(--_6-color)" }}>
                        {t("YourDashboardIsEmpty")}
                      </span>
                      <span style={{ color: "var(--_6-color)" }}>
                        {t("yourFirstWorkflow")}
                      </span>
                    </div>

                    <div style={{ marginBottom: "5%" }}>
                      <Button action={() => typeContent ? typeContent("Gmail") :handleShowContentAutomate("Gmail") }>
                        {" "}
                        <Automation
                          height="21px"
                          width="21px"
                          style={{ height: "21px", width: "21px" }}
                        />{" "}
                        {t("newAutomate")}
                      </Button>
                    </div>
                  </div>
                )}
                {userAutomations?.length > 0 &&
                  filteredData
                    ?.sort((a, b) => {
                      const order = selectedOption[t("alphabeticOrder")];
                      const nameA = (
                        a.inputValue ||
                        a.type ||
                        ""
                      ).toLowerCase();
                      const nameB = (
                        b.inputValue ||
                        b.type ||
                        ""
                      ).toLowerCase();
                      if (order === "A-Z") return nameA.localeCompare(nameB);
                      if (order === "Z-A") return nameB.localeCompare(nameA);
                      return 0;
                    })
                    .slice(page * limit, (page + 1) * limit)
                    .map((card, i) => {
                      // console.log(i)
                      const filteredAutomation = data.find(
                        (automation) => automation?.type === card?.type
                      );
                      return (
                        <>
                          {/* {JSON.stringify(card.selectedActionFrequency)} */}
                          <CardAutomate
                          index={i}
                            loadingTime={card.selectedActionFrequency || 0}
                            fullContent={true}
                            type={filteredAutomation?.type}
                            typeContent={typeContent}
                            handleShowContentAutomate={handleShowContentAutomate}
                            key={card.id}
                            name={filteredAutomation?.automateName}
                            nameTitle={card.inputValue}
                            image={filteredAutomation?.image}
                            rol={filteredAutomation?.role}
                            automationData={card}
                            isBorders={true}
                            last={i === dataFilter.length - 1}
                            id={card.id}
                            fromWhere={"selectedAutomate"}
                            searchTerm={searchTerm}
                            handleCloseNewClient={handleCloseNewClient}
                            showDeletePopup={showDeletePopup}
                            setShowDeletePopup={setShowDeletePopup}
                            setSelectedAutomateToDelete={
                              setSelectedAutomateToDelete
                            }
                            close={close}
                            setHideAutomate={setHideAutomate}
                            setRoleAutomate={setRoleAutomate}
                          />
                        </>
                      );
                    })}
              </div>
            </div>
            {filteredData.length > 20 && (
              <div className={styles.paginationTableContainer}>
                <PaginationTables
                  totalData={filteredData.length}
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  setLimit={setLimit}
                  father={"automate"}
                />
              </div>
            )}
          </div>
        )}

        {userAutomations?.length <= 0 && (
          <div className={styles.footer}>
            <IconLock />
            <span>{t("facturaAnalyzeData")}</span>
          </div>
        )}
      </div>
    </>
  );
};

export default Automate;
